<template>
  <div>
    <z-input
      v-model="name"
      :label="$t('Name of Subscription', 'Name of Subscription')"
      :is-disabled="type === 'view'"
    />
    <z-input
      v-model="quota"
      type="number"
      :label="$t('Text Analysis limit', 'Text Analysis limit')"
      :is-disabled="type === 'view'"
    />
    <z-button
      v-if="type === 'new'"
      type="primary"
      :text="$t('Create', 'Create')"
      @click="createSubscription"
    />
    <z-button
      v-if="type === 'edit'"
      type="primary"
      :text="$t('Save changes', 'Save changes')"
      @click="updateSubscription"
    />
  </div>
</template>

<script>
import { actionNames } from '@/admin/store'
import ZInput from '../ui/Input'
import ZButton from '../ui/Button'

export default {
  name: 'Subscription',
  components: { ZInput, ZButton },
  props: {
    type: { type: String, default: 'view' },
    subscription: { type: Object, default: () => ({}) }
  },
  data () {
    return {
      name: '',
      quota: 0
    }
  },
  watch: {
    subscription () {
      this.updateData()
    }
  },
  mounted () {
    this.updateData()
  },
  methods: {
    updateData () {
      this.name = this.subscription.name
      this.quota = this.subscription.quota
    },
    createSubscription () {
      this.$store.dispatch(actionNames.CREATE_SUBSCRIPTION, { name: this.name, quota: this.quota })
    },
    updateSubscription () {
      this.$store.dispatch(actionNames.UPDATE_SUBSCRIPTION, { id: this.subscription.id, name: this.name, quota: this.quota })
      this.$emit('updated')
    }
  }
}
</script>
